import styles from './embed-block.module.scss';

type EmbedBlockProps = {
	script: string;
};

/**
 * Lightweight placeholder for freeform Embed controls.
 * Scripts are not executed in v1; markup is rendered as static HTML when safe.
 */
export const EmbedBlock = ({ script }: EmbedBlockProps) => {
	const trimmed = script?.trim();
	if (!trimmed) {
		return null;
	}

	const looksLikeMarkup = trimmed.startsWith('<');

	if (!looksLikeMarkup) {
		return (
			<div
				className={styles.placeholder}
				data-embed-placeholder="true"
				aria-hidden="true"
			/>
		);
	}

	return (
		<div className="container">
			<div className="row">
				<div className="col-12">
					<div
						className={styles.root}
						dangerouslySetInnerHTML={{ __html: trimmed }}
					/>
				</div>
			</div>
		</div>
	);
};

export default EmbedBlock;
